import {
  COMMUNICATION_ISSUES,
  TENANT_DATES_MODIFICATIONS,
  TENANT_BC_CANCELLATION,
  TENANT_BOOKING_STATUS,
  LISTING_INACCURACY,
  PROPERTY_CONDITIONS,
  PERSONAL_CONFLICT,
  LAST_MINUTE_CANCEL,
  DESPOSIT_DISPUTE,
  TENANT_WRONG_CONTRACT,
  REQUEST_INVOICE,
  LIST_PAYMENTS,
  LISTING_DOUBTS,
  HELP_FIND_PROPERTY,
  TENANT_BUG,
  TENANT_ACCOUNT_ACCESS,
  TENANT_CHANGE_ACCOUNT_DETAILS,
  TENANT_OTHER
} from './tenantReasons';

const NON_BOOKING_CATEGORY = 'non_booking';
const BOOKING_CATEGORY = 'booking';

export const TENANT_CATEGORY_IDS = [NON_BOOKING_CATEGORY, BOOKING_CATEGORY];

const MY_BOOKING = 'my_booking';
const COMPLAINTS_DISPUTES = 'complaints_disputes';
const MY_PAYMENTS = 'my_payments';
const SEARCH = 'search';
const OTHER = 'other';

export const TENANT_SECTION_IDS = [
  MY_BOOKING,
  COMPLAINTS_DISPUTES,
  MY_PAYMENTS,
  SEARCH,
  OTHER
];

export const TENANT_CONFIG = {
  [BOOKING_CATEGORY]: {
    [MY_BOOKING]: [
      COMMUNICATION_ISSUES,
      TENANT_DATES_MODIFICATIONS,
      TENANT_BC_CANCELLATION,
      TENANT_BOOKING_STATUS
    ],
    [COMPLAINTS_DISPUTES]: [
      LISTING_INACCURACY,
      PROPERTY_CONDITIONS,
      PERSONAL_CONFLICT,
      LAST_MINUTE_CANCEL,
      DESPOSIT_DISPUTE,
      TENANT_WRONG_CONTRACT
    ],
    [MY_PAYMENTS]: [REQUEST_INVOICE, LIST_PAYMENTS]
  },
  [NON_BOOKING_CATEGORY]: {
    [SEARCH]: [LISTING_DOUBTS, HELP_FIND_PROPERTY],
    [OTHER]: [
      TENANT_BUG,
      TENANT_ACCOUNT_ACCESS,
      TENANT_CHANGE_ACCOUNT_DETAILS,
      TENANT_OTHER
    ]
  }
};
